import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { SalesPage } from "@/screens/Sales/components/SalesPage"

export const Route: AnyRoute = createFileRoute("/app/sales/")({
  beforeLoad: () => {
    if (window.innerWidth < 1024) {
      throw redirect({ to: "/app/tablet/sales/" })
    }
  },
  component: SalesPage,
})
